import React, { useRef, useImperativeHandle, useMemo } from "react";
import { useSelector } from "react-redux";
import ItemForm from "./ItemForm";

const EditItemForm = React.forwardRef(
  ({ item, onUpdate, onCancel, formError }, ref) => {
    const formRef = useRef();

    useImperativeHandle(ref, () => ({
      requestSubmit: () => {
        formRef.current?.requestSubmit();
      },
    }));

    const sections = useSelector((s) => s.careplan.sections);

    // const [initialValues, setInitialValues] = useState({});
    // const [loadedSectionAnswers, setLoadedSectionAnswers] = useState({});

    const initialValues = useMemo(
      () => ({
        id: item.id,
        title: item.title,
        description: item.description,
        imageFile: null,
        image_url: item.image_url,
        image_alt_text: item.image_alt_text || "",
        prompt_text: item.prompt_text,
        resource_link: item.resource_link,
        hide_from_service_user_specific: item.hide_from_service_user_specific,
        imageChanged: false,
      }),
      [item]
    );

    const initialSectionAnswers = useMemo(
      () => item.section_overrides || {},
      [item]
    );

    const initialSectionPrompts = useMemo(
      () => item.section_prompt_overrides || {},
      [item]
    );

    return (
      <ItemForm
        key={item.id}
        ref={ref}
        initialValues={initialValues}
        sections={sections}
        initialSectionAnswers={initialSectionAnswers}
        initialSectionPrompts={initialSectionPrompts}
        onSubmit={onUpdate}
        onCancel={onCancel}
        formError={formError}
      />
    );
  }
);

export default EditItemForm;
